import Srcset from "@/components/common/Srcset";
import { useEffect, useId, useState } from "react";
import {
  createAccountMigrate,
  activeCustomerByUrl,
  createUserLogin,
  checkCustomerExist,
  getCustomerDataById,
  performKlaviyoMerge
} from "@/helpers/userHelpers";
import { errorMessages } from "@/utils/constants";
import { generalConstants } from "@/utils/constants";
import { useRouter } from "next/compat/router";
import { useDispatch, useSelector } from "react-redux";
import { loggedInUser } from "@/redux/actions/loggedInUser";
import { reportError } from "@/helpers/errorHelper";
import { activeAccountLog } from "@/helpers/activeAccountLog";
import { checkIfEmail, validatePassword } from '@/helpers/generalHelper';
import InputField from "@/components/common/CommonInputComponent";
import CryptoJS from 'crypto-js';

const ActivateAccountTab = (props) => {
  const { styles, accountSidebarOpen, setShowResetPassword, setAutoFillEmail } = props;
  const [step, setStep] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState();
  const [passwordErrorMessage, setPasswordErrorMessage] = useState();
  const [passwordType, changePasswordType] = useState(true);
  const [formError, setFormError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonStatus, setButtonStatus] = useState(true);
  const emailId = useId();
  const passwordId = useId();
  const [alreadyAccountMsg, setAlreadyAccountMsg] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [showSignIn, setShowSignIn] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  var validateEmail;
  var validatePass;

  useEffect(() => {
    if (window.innerWidth > 768) {
      !accountSidebarOpen && setShowResetPassword();
    }
  }, [accountSidebarOpen]);

  useEffect(() => {
    if (router?.query?.url) {
      /* when user clicks on email button */
      let url_data = router.query.url.split('activate/');
      if (url_data && url_data.length > 1 && url_data[1]) {
        let cusId = url_data[1].split('/');
        cusId = cusId[0];
        setCustomerId(cusId);
      }
      setStep('activate-confirm');

    }
    if (props.emailAtActivateAccount && !router?.query?.url) {
      /* when user redirected to the active account tab from sign up/ sign in section */
      setStep('activate-invite');
    }
    // when redirected from thank you page, prepopulate user email in input field
    if(router?.query?.em){
      try{
        let encoded = router.query.em.split(' ').join('+');
        if(encoded){
          let decryptedEmail = CryptoJS.AES.decrypt(encoded, process.env.SECRET_KEY_CRYPTO).toString(CryptoJS.enc.Utf8);
          setEmail(decryptedEmail);
          if(document?.querySelector('.activate-account-form')){
            document.querySelector('.activate-account-form').value = decryptedEmail;
          }
        }
      }catch(error){
        reportError("Error in decoding email in activate account tab");
        reportError(error);
    }}
  }, [props.emailAtActivateAccount, router.query]);

  useEffect(() => {
    if (window.activeLogOnLoad && customerId) {
      /* To run log only once per page load */
      return;
    }
    if (step === 'activate-invite') {
      /* for step 1 */
      sendInitialLog();
    } else if (step === 'activate-confirm' && customerId) {
      /* after email link click */
      activeAccountLog({ customerId: customerId, stepId: 4 });
      window.activeLogOnLoad = true;
    }
  }, [step]);

  const sendInitialLog = async () => {
    /* get customer ID based on email */
    let customerData = await checkCustomerExist(props.email);
    setCustomerId(customerData.customerId);
    activeAccountLog({ customerId: customerData.customerId, stepId: 1 });
    window.activeLogOnLoad = true;
  }


  function handleEmailFormat(event) {
    let emailVal =
      event.target.email && event.target.email.value
        ? event.target.email.value
        : event.target.value;
    if (emailVal) {
      validateEmail = checkIfEmail(emailVal);
      if (!validateEmail) {
        if (formError) {
          setFormError("");
        }
        setEmailErrorMessage(errorMessages.authentication.invalidEmail);
      } else {
        setEmailErrorMessage(null);
      }
      if (email) {
      } else {
        setEmailErrorMessage(null);
      }
    } else {
      if (formError) {
        setFormError("");
      }
      setEmailErrorMessage(errorMessages.authentication.emptyEmail);
    }
  }

  function makeid(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const handleChange = (event) => {
    //Check All fileds are filled or not
    if (formError) {
      setFormError("");
    }
    switch (event.target.name) {
      case "email":
        setEmail(event.target.value);
        break;
      case "password":
        setPassword(event.target.value);
        break;
    }
  };

  function handlePasswordFormat(event) {
    let passwordVal =
      event.target.password && event.target.password.value
        ? event.target.password.value
        : event.target.value;
    if (passwordVal) {
      validatePass = validatePassword(passwordVal);
      if (!validatePass) {
        setPasswordErrorMessage(true);
        setAlreadyAccountMsg()
        setShowSignIn(false)
      } else {
        setPasswordErrorMessage(false);
      }
      if (password) {
      } else {
        setPasswordErrorMessage(false);
      }
    } else {
      setPasswordErrorMessage(true);
      setAlreadyAccountMsg();
      setShowSignIn(false)
    }
  }

  // Handles the submit event on form submit.
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!loading) {
      handlePasswordFormat(event);

      /* after email link clicked */
      if (step == 'activate-confirm') {
        if (!router.query.url) {
          let obj = { message: "Active URL error", url: router.query.url };
          activeAccountLog({ customerId: customerId, stepId: 5, message: JSON.stringify(obj) });
          return;
        }
        if (!validatePass) {
          activeAccountLog({ customerId: customerId, stepId: 5, message: JSON.stringify({
            message:"Tried invalid password",
            device:navigator.userAgent
          }) });
          return;
        }
        /* After clicking on the email active URL */
        setLoading(true);
        const response = await activeCustomerByUrl({
          activationUrl: router.query.url,
          password: event.target.password.value,
        });
        if (response && response.status == "200") {
          /* Customer active successfully */
          let expiry = false;
          await createUserLogin(response, response.customer, expiry);
          dispatch(loggedInUser(true));
          try {
            if(localStorage.getItem('klaviyo_external_id') && response?.customer?.email) {
              await performKlaviyoMerge(response?.customer?.email,localStorage.getItem('klaviyo_external_id'));        
            }      
          }
          catch(error) {
            reportError("klaviyo profile merge failed in activate accunt");
            reportError(error);
          }
          activeAccountLog({ customerId: customerId, stepId: 0,message:JSON.stringify({
            url:router.query.url,
            device:navigator.userAgent
          }) });
          setLoading(false);
          window.location.href = `${process.env.NETLIFY_URL}/account`;
        }
        else {
          activeAccountLog({ customerId: customerId, stepId: 5, message: JSON.stringify({error:response,
            url:router.query.url,
            device:navigator.userAgent
          })
        });
          reportError("User Migrated reset password failed");
          reportError(response);
          if (response.customerUserErrors && response.customerUserErrors.length && response.customerUserErrors[0].code == "ALREADY_ENABLED") {
            if (customerId) {
              const userData = await getCustomerDataById({ 'id': customerId });
              if (userData && userData.email) {
                setAutoFillEmail(userData.email);
              }
            }
            setAlreadyAccountMsg(errorMessages.authentication.account_already_enabled);
            setShowSignIn(true)
          } else {
            setAlreadyAccountMsg(errorMessages.authentication.invalid_activation_link);
            setShowSignIn(false)
          }
          setLoading(false);
        }
        return;
      }

      /* after redirection from sign in / sign up */
      const thisEmail = event.target?.email?.value;
      handleEmailFormat(event);
      if (step == 'activate-invite') {
        if (!validateEmail) {
          activeAccountLog({ customerId: customerId, stepId: 3, message: 'Tried invalid email' });
          return;
        }
        let strong_password = process.env.SECRET_PASSWORD_KEY + makeid(10);
        const data = {
          email: thisEmail,
          password: strong_password,
        };
        setLoading(true);
        const check_invited_user = await checkCustomerExist(thisEmail);
        if (check_invited_user) {
          const response = await createAccountMigrate(data);
          if (!response) {
            activeAccountLog({ customerId: customerId, stepId: 3, message: 'Creating Customer Limit exceeded and empty response' });
            setAlreadyAccountMsg(errorMessages.authentication.tryAgainLater);
            setShowSignIn(false)
            setLoading(false);
            reportError(``)
            return;
          }
          if (response && response.status === 407) {
            setShowResetPassword("activateAccount");
            setLoading(false);
            activeAccountLog({ customerId: customerId, stepId: 2 });
            return;
          }
          if (response && response.status === 406) {
            activeAccountLog({ customerId: customerId, stepId: 3, message: "Already enabled account" });
            setAlreadyAccountMsg(errorMessages.authentication.account_already_enabled);
            setShowSignIn(true)
            setAutoFillEmail(thisEmail);
            setLoading(false);
            return;
          }
        } else {
          let obj = {};
          obj = { message: "Issue with email", response: response };
          activeAccountLog({ customerId: customerId, stepId: 3, message: JSON.stringify(obj) });
          setAlreadyAccountMsg(errorMessages.authentication.invalidEmail);
          setShowSignIn(false)
          setLoading(false);
          return;
        }
      }
    }
  };

  const handleBlurOut = (target, placeholderText) => {
    if (target) {
      target.placeholder = placeholderText;
    }
  };

  const togglePasswordVisibility = () => {
    changePasswordType(!passwordType);
  };

  const handleClick = () => {
    setEmail("");
    setPassword("");
  
    if (isPWA) {
      window.location.href = "/login";
    } else {
      setShowResetPassword(false);
    }
  };

  return (
    <>
      <a
        onClick={handleClick}
        className={!isPWA?"forgot_auth_back":"pwa_forgot_auth_back"}
      >
        <Srcset
          requirePath={true}
          svgFile={true}
          src="/images/Icons/Arrow/Right/large.svg"
          alt="back-button"
          height="14.31"
          width="24"
          className="right_arrow"
          tabIndex={0}
        />
      </a>
      <div className={`${styles.account_auth} ${styles.activate_account}`}>
        <div className={`${styles.account_tab}`}>
          <div className={`${styles.tab_head} ${styles.activate_heading}`}>
            <div
              className={`xx-large-md xx-large-sm x-large-xs light-xs ${styles.no_border} ${styles.tab_item} ${styles.active}`}
            >
              <span>Activate account</span>
            </div>
          </div>
          <div className={`small-md small-sm x-small-xs bold ${styles.activate_msg}`}>
            {step == 'activate-invite' ? errorMessages.authentication.migratedInvitedCustomerMessage : errorMessages.authentication.migratedCustomerMessage}
          </div>
          <div className={`${styles.tab_content}`}>
            <div className={`${styles.tab_content_item}`}>
              <form onSubmit={handleSubmit} className={`${styles.form_wrap}`}>
                {(step == 'activate-invite') && (
                  <InputField
                  type="text"
                  id={emailId}
                  name="email"
                  label="Email*"
                  placeholder=" "
                  autoComplete="email"
                  ariaLabel="your-email"
                  className="normal-md small-xs normal-sm activate-account-form"
                  defaultValue={props.email ? props.email : email}
                  errorMessage={emailErrorMessage}
                  formError={formError}
                  onFocus={e => e.currentTarget.placeholder = ``}
                  onChange={handleChange}
                  onBlur={(e) => {handleEmailFormat(e); 
                  }}
                  alreadyAccountMsg={alreadyAccountMsg}
                  isEmail={true}
                  isActivateAccountTab={true}
                />
                )}
                {(step == 'activate-confirm') && (
                  <InputField
                  type={passwordType ? 'password' : 'text'}
                  id={passwordId}
                  name="password"
                  label="New password*"
                  placeholder=" "
                  autoComplete="password"
                  ariaLabel="your-new-password"
                  className="normal-md small-xs small-sm"
                  errorMessage={passwordErrorMessage}
                  onFocus={(e) => (e.currentTarget.placeholder = '')}
                  onChange={handleChange}
                  onBlur={(e) => {
                    handlePasswordFormat(e);
                  }}
                  value={password}
                  alreadyAccountMsg={alreadyAccountMsg}
                  isPassword={true}
                  togglePasswordVisibility={togglePasswordVisibility}
                  isPasswordVisible={!passwordType}
                  isActivateAccountTab={true}
                />
                )}
                <div className={`${styles.form_btn}`}>
                  {!showSignIn && <button
                    type="submit"
                    className={`normal btn-primary ${styles.btn_loading} ${loading ? "loading" : ""
                      }`}
                  >
                    <span>{step == 'activate-confirm' ? "Complete activation" : "Activate account"}</span>
                  </button>}
                  {showSignIn && <button
                    className={`normal btn-primary ${styles.btn_loading} ${loading ? "loading" : ""
                      }`} onClick={() => {
                        setEmail("");
                        setPassword("");
                        setShowResetPassword(false);
                      }}
                  >
                    <span>Sign in</span>
                  </button>}
                </div>
                <div className={`${styles.form_assistance} ga-help`}>
                  <p className="small-xs normal-sm normal-md para-with-link">
                    Need assistance? Contact us by{" "}
                    <a href={`mailto:${generalConstants.help_email}`} tabIndex={0}>
                      <span className="ga-help">email</span>
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivateAccountTab;
